import axios from "axios";

const BASE_URL =
  window.location.hostname === "localhost"
    ? process.env.REACT_APP_BACKEND_URL
    : window.location.origin;

export const API_BASE = `${BASE_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export default api;
